<template>
  <div :style="ruleBtnStyles" @click="showRulesPop">
    <c-base-dialog
      :option="option"
      @close="closeRulesPop()"
      v-transfer-dom
      v-model="isShowRulesPop"
      :class="getCss('bind-qq-base')"
    >
      <template slot="body">
        <section :class="getCss('rule-box')">
          <ul :class="getCss('rules-body')">
            <li>
              <span v-html="replaceSpace(configurationData.ruleContent)"></span>
            </li>
          </ul>
        </section>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
export default {
  name: 'CShanxianActitityRules',
  components: { [CDialog.name]: CDialog },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-actitity-rules-',
      isShowRulesPop: false,
    };
  },
  computed: {
    ruleBtnStyles() {
      return {
        ...this.styles.base,
        backgroundImage: `url(${this.configurationData.backgroundImg || ''})`,
        backgroundSize: '100% 100%',
        backgroundPosition: '0 0',
      };
    },
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: this.configurationData?.contentTitle ? this.configurationData.contentTitle : '活动规则',
        fotter: false,
      });
    },
  },
  async mounted() {
    console.log('rules configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {},
    showRulesPop() {
      if (!this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return;
      }
      this.isShowRulesPop = true;
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '03');
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '02', '04');
    },
    closeRulesPop() {
      this.isShowRulesPop = false;
    },
    replaceSpace(str) {
      return str.replace(/[\n]/g, '<br/>');
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
